import { gsap } from 'gsap';
import barba from '@barba/core';

export default {
	name: 'info',
	from: {
		custom: ({ current, next, trigger }) => {
			const mobileBreakpoint = window.matchMedia('(max-width:991px)');

			if (mobileBreakpoint.matches) {
				return false;
			}

			return true;
		},
		namespace: ['template-info'],
	},
	to: {
		namespace: ['template-info'],
	},
	leave({ current, next, trigger }) {
		document.dispatchEvent(new CustomEvent('disable-scroll'));
		document.dispatchEvent(new CustomEvent('remove-cursors'));
		barba.menu.close();
		barba.logoLayerDirector.handleTransition();
		barba.logoLayerDirector.newCode('');

		gsap.set(current.container.querySelector('.l-info__content-wrapper'), {
			opacity: 0,
		});
	},
	afterLeave({ current, next, trigger }) {
		const blurLayer = document.querySelector('[data-blur-layer]');
		blurLayer.classList.remove('blur-layer--blurred');
	},
	beforeEnter({ current, next, trigger }) {
		window.scrollTo(0, -1);
		setTimeout(() => {
			window.scrollTo(0, -1);
		}, 100);

		barba.menu.update(next.container);

		gsap.set(current.container, {
			position: 'absolute',
			top: 0,
			left: 0,
			width: '100%',
		});

		gsap.set(next.container.querySelector('.l-info__content-wrapper'), {
			opacity: 0,
		});
	},
	enter({ current, next, trigger }) {
		return new Promise((resolve) => {
			gsap.to(next.container.querySelector('.l-info__content-wrapper'), {
				opacity: 1,
				ease: 'none',
				duration: 0,
				onComplete: () => {
					resolve();
				},
			});
		});
	},
	after({ current, next, trigger }) {
		return new Promise((resolve) => {
			document.dispatchEvent(new CustomEvent('enable-scroll'));

			resolve();
		});
	},
};
